export default "__VITE_ASSET__a7e70a2c__"